import React from 'react';
import Typical from 'react-typical';
import './Blog.css';

const Blog = () => {
  return (
    <section className='blog' id='blog'>
      {/* <h1>Coming soon</h1> */}
      <h1>
        <Typical
          loop={Infinity}
          steps={['Blog', 2000, 'Coming soon.....', 4000]}
        />
      </h1>
    </section>
  );
};

export default Blog;
